// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/reports/SummaryReportModal.module.css */
.SummaryReportModal_backdrop__QIzHi {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.SummaryReportModal_modal__DuPg8 {
  background: #fff;
  width: 90%;
  max-width: 1000px;
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 8px;
  padding: 1rem;
  position: relative;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}
.SummaryReportModal_header__L6ifP {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.SummaryReportModal_closeBtn__HcSo3 {
  background: none;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
}
.SummaryReportModal_routeInfo__oCHGu {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 2rem;
  margin: 1rem 0;
}
.SummaryReportModal_exportBtn__BL7Qs {
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  margin-bottom: 1rem;
}
.SummaryReportModal_exportBtn__BL7Qs:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.SummaryReportModal_noData__oAFAn {
  text-align: center;
  color: #666;
  padding: 1rem 0;
}
.SummaryReportModal_tableWrapper__sesuZ {
  overflow-x: auto;
}
.SummaryReportModal_table__2EJaO {
  width: 100%;
  border-collapse: collapse;
}
.SummaryReportModal_table__2EJaO th,
.SummaryReportModal_table__2EJaO td {
  border: 1px solid #ddd;
  padding: 0.5rem;
  text-align: left;
  vertical-align: top;
}
.SummaryReportModal_table__2EJaO th {
  background: #f5f5f5;
  position: sticky;
  top: 0;
  z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Manager/ReportsPage/components/reports/SummaryReportModal.module.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;;EAEE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ","sourcesContent":["/* src/components/reports/SummaryReportModal.module.css */\r\n.backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0,0,0,0.4);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n.modal {\r\n  background: #fff;\r\n  width: 90%;\r\n  max-width: 1000px;\r\n  max-height: 80vh;\r\n  overflow-y: auto;\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  position: relative;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.2);\r\n}\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n.closeBtn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.25rem;\r\n  cursor: pointer;\r\n}\r\n.routeInfo {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 1rem 2rem;\r\n  margin: 1rem 0;\r\n}\r\n.exportBtn {\r\n  background: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 0.5rem 0.75rem;\r\n  cursor: pointer;\r\n  margin-bottom: 1rem;\r\n}\r\n.exportBtn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n.noData {\r\n  text-align: center;\r\n  color: #666;\r\n  padding: 1rem 0;\r\n}\r\n.tableWrapper {\r\n  overflow-x: auto;\r\n}\r\n.table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n.table th,\r\n.table td {\r\n  border: 1px solid #ddd;\r\n  padding: 0.5rem;\r\n  text-align: left;\r\n  vertical-align: top;\r\n}\r\n.table th {\r\n  background: #f5f5f5;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"backdrop": `SummaryReportModal_backdrop__QIzHi`,
	"modal": `SummaryReportModal_modal__DuPg8`,
	"header": `SummaryReportModal_header__L6ifP`,
	"closeBtn": `SummaryReportModal_closeBtn__HcSo3`,
	"routeInfo": `SummaryReportModal_routeInfo__oCHGu`,
	"exportBtn": `SummaryReportModal_exportBtn__BL7Qs`,
	"noData": `SummaryReportModal_noData__oAFAn`,
	"tableWrapper": `SummaryReportModal_tableWrapper__sesuZ`,
	"table": `SummaryReportModal_table__2EJaO`
};
export default ___CSS_LOADER_EXPORT___;
